var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.585,
    height: 22.586,
    viewBox: "0 0 22.585 22.586",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175",
    transform: "translate(-45 -45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M45,135.015a.793.793,0,0,1,.84-.492c1.147.016,2.294.006,3.44.006h.258V133.24a10.815,10.815,0,0,1-1.409-.6A3.983,3.983,0,0,1,46.1,129.2c-.013-.323-.012-.647,0-.97a.64.64,0,0,1,.642-.648.661.661,0,0,1,.652.666,11.441,11.441,0,0,0,.137,1.639,2.679,2.679,0,0,0,2.019,1.937c.011-.227.01-.452.035-.674a1.046,1.046,0,0,1,.97-.948,3.033,3.033,0,0,1,.308-.015h4.781v.285q0,3.573,0,7.147a1.422,1.422,0,0,0,.035.349.642.642,0,0,0,1.237,0,1.422,1.422,0,0,0,.035-.349q0-3.573,0-7.147v-.285h.238q2.3,0,4.609,0a1.1,1.1,0,0,1,1.2.854,7.429,7.429,0,0,1,.053.787,2.637,2.637,0,0,0,1.286-.706A2.861,2.861,0,0,0,65.2,129c0-.243,0-.485,0-.728a.653.653,0,0,1,.647-.691.644.644,0,0,1,.646.668,5.458,5.458,0,0,1-.344,2.508,4.1,4.1,0,0,1-2.91,2.373c-.063.015-.126.032-.2.051v1.352h.24c1.206,0,2.411,0,3.617,0a.646.646,0,0,1,.639.885.605.605,0,0,1-.511.4,2.435,2.435,0,0,1-.286.013H63.03c0,.438-.005.854.008,1.27,0,.043.1.105.17.12a4.1,4.1,0,0,1,2.871,2.236,3.834,3.834,0,0,1,.413,1.742c0,.294.007.588,0,.882a.651.651,0,0,1-.658.7.665.665,0,0,1-.64-.7,8.1,8.1,0,0,0-.146-1.636,2.7,2.7,0,0,0-2.016-1.924,6.742,6.742,0,0,1-3,5.939,6.421,6.421,0,0,1-4.461,1.1,6.553,6.553,0,0,1-4.389-2.323,6.732,6.732,0,0,1-1.619-4.7,2.168,2.168,0,0,0-.938.4,2.828,2.828,0,0,0-1.236,2.407c0,.257,0,.515,0,.772a.646.646,0,1,1-1.291.011,5.507,5.507,0,0,1,.336-2.51,4.089,4.089,0,0,1,2.923-2.388c.166-.038.212-.1.207-.261-.01-.372,0-.745,0-1.141h-.288c-1.147,0-2.294-.009-3.44,0a.769.769,0,0,1-.828-.509Z",
    transform: "translate(0 -78.015)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M166.72,45a1.952,1.952,0,0,1,.325.246.613.613,0,0,1,.082.7c-.155.347-.306.7-.441,1a9.124,9.124,0,0,1,1.1.578,2.664,2.664,0,0,1,1.142,2.135c.02.388,0,.778,0,1.186h-9.966a3.919,3.919,0,0,1,.554-2.758,2.816,2.816,0,0,1,1.394-.99c.1-.03.194-.059.312-.1l-.4-.9c-.249-.561-.177-.8.338-1.109h.309a.874.874,0,0,1,.533.545c.173.42.371.829.549,1.247a.226.226,0,0,0,.244.162q1.145-.009,2.289,0a.226.226,0,0,0,.244-.162c.178-.418.375-.828.549-1.247a.874.874,0,0,1,.533-.545Z",
    transform: "translate(-107.649)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M209.638,45a.874.874,0,0,0-.533.545c-.173.42-.371.829-.549,1.247a.226.226,0,0,1-.244.162q-1.145-.009-2.289,0a.226.226,0,0,1-.244-.162c-.178-.418-.375-.828-.549-1.247A.874.874,0,0,0,204.7,45Z",
    transform: "translate(-150.876)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBug);
export default __webpack_public_path__ + "static/media/bug.987cc2a0b601f86ed21294c75ed2e282.svg";
export { ForwardRef as ReactComponent };